import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CommonFunctionService, UserPOSData } from '../../../services/Common/common-function.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { environment } from '../../../../environments/environment';
import { Validators, FormControl } from "@angular/forms";
import{OrderMaster} from '../../../POS/models/order-master';
import * as CryptoJS from 'crypto-js';
import { CustomerService } from '../../POSServices/Customers/customer.service';
@Component({
  selector: 'app-order-management',
  templateUrl: './order-management.component.html',
  styleUrls: ['./order-management.component.scss']
})
export class OrderManagementComponent implements OnInit {
  amountcompare;
  posid:any;
  listoforders:any;
  PaymentType= new FormControl("", [Validators.required]);
  orderid= new FormControl("", [Validators.required]);
  OrderStatus = new FormControl("", [Validators.required]);
  transactionStatus = new FormControl("", [Validators.required]);
  Fromdate1: any;
  todate1: any;
  fromdate = new FormControl("", [Validators.required]);
  todate = new FormControl("", [Validators.required]);
  Amount = new FormControl("", [Validators.required]);
  amountcheck= new FormControl("", [Validators.required]);
  // OrderId= new FormControl("", [Validators.required]);
  TransactionId = new FormControl("", [Validators.required]);
  isreportsbtnActive: boolean = false;
  isStartDateGreaterthenEndDate: boolean = false;
  isCustomDateSelected: boolean = false;
  daterange = new FormControl("", [Validators.required]);
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "2" },
    { text: "current week", value: "4" },
    { text: "Last Week", value: "1" },
    { text: "This Month", value: "1" },
    { text: "Last Month", value: "2" },
    { text: "Custom Date Range", value: "4" }
  ];
  PaymentTypes = [
    { text: "CreditCard", value: "1" },
    { text: "DebitCard", value: "2" },
    { text: "Upi", value: "4" },
    { text: "PrepaidCard", value: "1" },
    { text: "NetBanking", value: "2" },
    { text: "E-wallet", value: "E-wallet" },
    { text: "Cash", value: "Cash" },
    { text: "Draft", value: "Draft" },
    { text: "All", value: "All" },

  ];
  symbol = [
    { text: "=", value: "1" },
    { text: "<", value: "2" },
    { text: ">", value: "4" },
    { text: "<=", value: "1" },
    { text: ">=", value: "2" },
    { text: "<>", value: "4" },
  ];

  Status = [
    { text: "Approved", value: "1" },
    { text: "Decline", value: "2" },
    { text: "Pending", value: "4" },
    { text: "All", value: "1" },
  ];
  Ostatus = [
    { text: "Submitted", value: "1" },
    { text: "Shipped", value: "2" },
    { text: "Delivered", value: "3" },
    { text: "Completed", value: "4" },
    { text: "cancelled", value: "5"},
  ];
  Dfiltering:boolean = true;
  Rfromdate: boolean = false;
    filtering:boolean=false;
  posId: any;
  rows = [];
  temp = [];
  currency:any;

  constructor(private service:CustomerService , private commonfunction: CommonFunctionService) 
  {
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    this.currency = this.commonfunction.GetCurrencysymbol();
    this.posId= merchantdata.PosSubscriptionId;

        this.GetOrderManagement((data) => {
          // cache our list
          // this.temp = _clone(data);
          // this.rows = _clone(data);
      });
   
   }

   filters()
   {
     this.filtering = !this.filtering;
   }

   selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
      // this.search();

    }
  }
  search() {
    this.GetTransactionDatafilter((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.rows = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);
    });
  }
  GetTransactionDatafilter(cb) {
    var daterange = this.daterange.value;
    var TransactionId = this.TransactionId.value;
    var Amount = this.Amount.value;
    this.amountcompare = this.amountcheck.value;
    var transactionStatus = this.transactionStatus.value;
    var orderstatus = this.OrderStatus.value;
    var orderid=this.orderid.value;
    var paymenttype=this.PaymentType.value;
    if(paymenttype=="CreditCard")
    {
      paymenttype='2';
    }
    else if(paymenttype=="Cash")
    {
      paymenttype='1';
    }
    else if(paymenttype=="DebitCard")
    {
      paymenttype='3';
    }
    else if(paymenttype=="E-wallet")
    {
      paymenttype='4';
    }
    else if(paymenttype=="NetBanking")
    {
      paymenttype='5';
    }
    else if(paymenttype=="PrepaidCard")
    {
      paymenttype='6';
    }
    else if(paymenttype=="Upi")
    {
      paymenttype='7';
    }
    else if(paymenttype=="Draft")
    {
      paymenttype='0';
    }
    else 
    {
      paymenttype='10';
    }
    
    if (Amount == "") {
      Amount = '0';
    }
  var ostatus=this.OrderStatus.value;
  if(ostatus=="Submitted")
    {
      ostatus='1';
    }
    else if(ostatus=="Shipped")
    {
      ostatus='2';
    }
    else if(ostatus=="Delivered")
    {
      ostatus='3';
    }
    else if(ostatus=="Completed")
    {
      ostatus='4';
    }
    else if(ostatus=="cancelled")
    {
      ostatus='5';
    }
    else
    {
      ostatus='0';
    }
    if (Amount == "") {
      Amount = '0';
    }

    if (daterange == "Today") {

      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);


    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.Fromdate1 = tomorrow;
      this.todate1 = tomorrow;

    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));


      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);


    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Month") {
      // var date = new Date();                
      // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
      var date = new Date();
      this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();


    }
    else if (daterange == "Custom Date Range") {

      this.Fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;
    }
    else {
      // this.Fromdate1 = new Date().toISOString().slice(0, 10);
      // this.todate1 = new Date().toISOString().slice(0, 10);
      this.Fromdate1 = '01/01/1990';
      this.todate1 ='01/01/1990';
    }
    if (transactionStatus == 'Approved') {
      transactionStatus = '1';
    }
    else if (transactionStatus == 'Decline') {
      transactionStatus = '2';
    }
    else if (transactionStatus == 'Pending') {
      transactionStatus = '4';
    }
    else if (transactionStatus == 'All') {
      transactionStatus = '3';
    }
    else {
      transactionStatus = '0';
    }
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    let form = {
   
      PosSubscriptionId:merchantdata.PosSubscriptionId,
      FromDate:this.Fromdate1, 
      ToDate:this.todate1,
      transactionStatus:transactionStatus,
      TransactionId:TransactionId,
      Amount:Amount,
      AmountCheck:this.amountcompare,
      OrderStatus:ostatus,
      OrderId:orderid,
      PaymentType:paymenttype,
      
      };
    this.service.FilteringOrderDetails(form).subscribe(data => {
    
    if(data !=null)
    {
      this.temp = _clone(data);
      this.rows = _clone(data);;
    }
  });
  
    // let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    // const req = new XMLHttpRequest();
    // req.open('GET',
    //   environment.FilteringOrderDetails + "?PosSubscriptionId=" +  merchantdata.PosSubscriptionId + "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1 + "&transactionStatus=" + transactionStatus
    //   + "&TransactionId=" + TransactionId +"&Amount=" + Amount + "&AmountCheck=" + amountcompare +"&OrderStatus="+ostatus+"&OrderId="+orderid+"&PaymentType="+paymenttype);
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };
    // req.send();
  }

  ngOnInit() {
  }

  GetOrderManagement(cb) {
    const req = new XMLHttpRequest();
    //this.listoforders=localStorage.getItem('Orderslist')
    if(this.listoforders ==null)
    {
      this.service.GetordermanagementListUrl(this.posId).subscribe(data => {   
      if(data !=null)
      {
        this.temp = _clone(data);
        this.rows = _clone(data);
      }
      // var  employeelist = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(this.rows), 'Secret Passphrase').toString());
      // localStorage.setItem("Orderslist",employeelist);
    });
    // req.open('GET',environment.GetordermanagementListUrl + "?PosSubscriptionId=" + this.posId);
    // req.onload = () => {
    //     cb(JSON.parse(req.response));
    //     // localStorage.setItem("Orderslist",req.response);
    //     var encrypted = CryptoJS.AES.encrypt(req.response, "Secret Passphrase", {
    //       // format: JsonFormatter
    //     });
    //     localStorage.setItem("Orderslist",encrypted);
    // };

    // req.send();
  }
  else{
  //   if(orderrespone[0].posSubscriptionId==this.posId)
  //   {
  //   this.rows  = JSON.parse(localStorage.getItem('Orderslist'));
  // }
  // else{
  //   localStorage.removeItem('Orderslist');
  //   window.location.reload();
  // }
  let  decrypteddata = localStorage.getItem('Orderslist');
  var deData= CryptoJS.AES.decrypt(decodeURIComponent(decrypteddata), 'Secret Passphrase'); 
  let data=deData.toString(CryptoJS.enc.Utf8);
if(data =="")
{
  localStorage.removeItem('Orderslist');
  window.location.reload();
}
else
{
  this.rows=JSON.parse(data);
  if(this.rows.length !=0)
  {
    if(this.rows[0].posSubscriptionId==this.posId)
    {
    this.rows=JSON.parse(data);
    }
    else{
    this.rows=[];
    localStorage.removeItem('Orderslist');
    window.location.reload();
    }
  }
  else
  {
    localStorage.removeItem('Orderslist');
    window.location.reload();
  }
  
}

  }
}
clearcache()
{
  localStorage.removeItem('Orderslist');
  window.location.reload();
}
checkDateRange() {
  if (this.fromdate.value != "" && this.todate.value != "") {
      if (this.fromdate.value > this.todate.value) {
          this.isreportsbtnActive = false;
          this.isStartDateGreaterthenEndDate = true;
      }
      else {
          this.isreportsbtnActive = true;
          this.isStartDateGreaterthenEndDate = false;
      }
  }
  else {
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
  }
}
resetForm(){
  this.daterange.reset('');
  this.fromdate.reset('');
  this.todate.reset('');
  this.transactionStatus.reset('');
  this.PaymentType.reset('');
  this.amountcheck.reset('');
  this.Amount.reset('');
  this.TransactionId.reset('');
  this.orderid.reset('');
  this.OrderStatus.reset('');
  this.rows=[];
 }


}









